import React from 'react';
import { UserX } from 'lucide-react';

const LibraryShareModal = ({
  showShareModal,
  sharedWith,
  newUser,
  setNewUser,
  unshareUser,
  shareBooks,
  setShowShareModal
}) => {
  return (
    showShareModal && (
      <div className="book-details-modal">
        <article className="modal-content">
          <h2>Sharing</h2>
          {/* Display shared with */}
          {sharedWith.length > 0 && sharedWith[sharedWith.length - 1].name.length > 0 ? (
            <div className="share-panel">
              <h3>Shared With:</h3>
              {sharedWith.map((user, index) => (
                <ul key={index}>
                  <div>
                    <label className='label' key={index}>{user.name}</label>
                    <button className='search-button-3 black' onClick={() => unshareUser(user.name)}>
                      <UserX size={16} />
                    </button>
                  </div>
                </ul>
              ))}
            </div>
          ) : (
            <div className="share-panel">Not Sharing with Anyone.</div>
          )}

          {/* Share with new user */}
          <div className="share-panel">
            <h3>Share with New User:</h3>
            <input
              className='search-box-add'
              type="text"
              value={newUser}
              onChange={(e) => setNewUser(e.target.value)}
            />
            <div className="edit-modal-buttons">
              <button className='search-button' onClick={shareBooks}>Share</button>
              <button className='search-button' onClick={() => setShowShareModal(false)}>Close</button>
            </div>
          </div>
        </article>
      </div>
    )
  );
};

export default LibraryShareModal;
